<template>
  <div>
    <div class="reinvite__wrapper">
      <b-button variant="primary" class="reinvite__button" @click="showForm()">
        Add User
      </b-button>
    </div>
    <EditProjectUserModal
      ref="add-user-modal"
      :mode="'Add'"
      :projectId="projectId"
      :users="users"
      :organizations="organizations"
      @submitted="addUserSubmit">
    </EditProjectUserModal>
  </div>
</template>

<script>
import EditProjectUserModal from "@/components/modals/EditProjectUserModal.vue";

export default {
  name: "AddProjectUserButton",
  props: {
    projectId: { type: String, default: '' },
    users: { type: Array, default: () => [] },
    organizations: { type: Array, default: () => [] }
  },
  components: {
    EditProjectUserModal
  },
  methods: {
    showForm(){
      this.$refs['add-user-modal'].show();
    },
    addUserSubmit(){
      this.$emit('update');
    }
  }
}

</script>

<style lang="scss" scoped>
.reinvite {
  &__wrapper {
    display: flex;
    justify-content: flex-end;
  }
  &__button {
    margin-bottom: 20px;
    width: 115px;
  }
}
</style>